/* global Word console */

export async function insertText(text: string) {
  // Write text to the document.
  try {
    await Word.run(async (context) => {
      let body = context.document.body;
      body.insertParagraph(text, Word.InsertLocation.end);
      await context.sync();
    });
  } catch (error) {
    console.log("Error: " + error);
  }
}

/**
 * Get the full text content of the current document
 */
export async function getDocumentContent(): Promise<string> {
  try {
    return await Word.run(async (context) => {
      const body = context.document.body;
      body.load("text");
      await context.sync();
      return body.text;
    });
  } catch (error) {
    console.error("Error getting document content:", error);
    throw new Error("Failed to read document content");
  }
}

/**
 * Get the full document file as a Blob (.docx binary with formatting preserved)
 */
export async function getDocumentFile(): Promise<Blob> {
  return new Promise((resolve, reject) => {
    Office.context.document.getFileAsync(
      Office.FileType.Compressed,
      { sliceSize: 65536 },
      async (result) => {
        if (result.status === Office.AsyncResultStatus.Failed) {
          reject(new Error(result.error.message));
          return;
        }
        const file = result.value;
        const slices: BlobPart[] = [];

        try {
          for (let i = 0; i < file.sliceCount; i++) {
            const slice = await new Promise<Office.Slice>((res, rej) => {
              file.getSliceAsync(i, (sliceResult) => {
                if (sliceResult.status === Office.AsyncResultStatus.Failed) {
                  rej(new Error(sliceResult.error.message));
                } else {
                  res(sliceResult.value);
                }
              });
            });
            slices.push(new Uint8Array(slice.data));
          }
          file.closeAsync();

          const blob = new Blob(slices, {
            type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          });
          resolve(blob);
        } catch (err) {
          file.closeAsync();
          reject(err);
        }
      }
    );
  });
}

/**
 * Get the document filename (if available)
 */
export async function getDocumentFilename(): Promise<string | undefined> {
  try {
    return await Word.run(async (context) => {
      const properties = context.document.properties;
      properties.load("title");
      await context.sync();
      return properties.title || undefined;
    });
  } catch (error) {
    console.warn("Could not get document filename:", error);
    return undefined;
  }
}

